/**
 * CR-21415: Inverted message map for the CertsControlsGroup component.
 * @property {string} 'Showing Records: {lastVisible} of {totalItems}' - Displays the last fully visible record index and total count.
 */
const invertedMessages = {
  'Showing Records: {lastVisible} of {totalItems}':
    'certs.showing.records.info',
  SaviCompanion: 'certs.savi.companion',
};

export default invertedMessages;
